"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllReserveOfObligation = void 0;
function getAllReserveOfObligation(obligation, allReserve, reserveSet) {
    if (obligation) {
        obligation.info.deposits.map((collateral) => {
            allReserve.map((reserve) => {
                if (collateral.depositReserve.equals(reserve.pubkey)) {
                    reserveSet.add(reserve);
                }
            });
        });
        obligation.info.borrows.map((collateral) => {
            allReserve.map((reserve) => {
                if (collateral.borrowReserve.equals(reserve.pubkey)) {
                    reserveSet.add(reserve);
                }
            });
        });
    }
}
exports.getAllReserveOfObligation = getAllReserveOfObligation;
